import { FunctionComponent } from 'react';

import { Container as RadixContainer, ContainerProps } from '@radix-ui/themes';

export const Container: FunctionComponent<ContainerProps> = (
  props: ContainerProps
) => {
  return <RadixContainer {...props} />;
};
